
import { Component, Vue, Watch } from "vue-property-decorator";
import { GoodsOrderService, AddressService,rightsService, EmployerActivityService } from "src/services";
import { Toast, Dialog } from "vant";
import dayjs from "dayjs";
import { CHECK_STATUS, ORDER_STATUS } from "src/enums";
import { Pay, tools } from "src/utils";

@Component
export default class GoodsDetail extends Vue
{
    /**
     * 数据模型
     * @private
     * @returns any
     */
    private dataModel: any =
    {
        address: "",
        addressId:"",
        marketPrice: "",
        phone: "",
        price: null,
        productId: null,
        productName: "", 
        productPict:  "",
        productQty:  null,
        productTypeStr:"",
        receiverName: "",
        supplierId: null,
        supplierLogo:"",
        supplierName: "",
        unitMarketPrice: null,
        unitPrice: null,
        rightsId: 0,
    };

    /**
     * 选择优惠券
     * @protected
     * @returns boolean
     */
    protected showCouponPopup: boolean = false;

    /**
     * 优惠券信息
     * @private
     * @returns any
     */
    private couponInfo: any =
    {
        finalReduceAmount: null,
        finalAmount: null,
        couponId: null,
    };

    /**
     * 可用优惠券列表
     * @private
     * @returns any
     */
     private couponList: any = [];

    /**
     * 卡片信息
     * @private
     * @returns any
     */
     private cardInfo: any = {
        orderId: 0,
        rightsMemberName: "",
        memberId: 0,
        memberName: "",
        phone: "",
        cardNo: "",
        rightsId: 0,
        rightsName: "",
        backgroundColor: "",
        rightsDesc: "",
        activedLimitTime: "",
        activedLimitTimeStr: "",
        activedEffTime: "",
        activedEffTimeStr: ""
    };

    /**
     * 商品数量
     * @private
     * @returns number
     */
    protected goodsNum: number = 1;


    /**
     * 商品详情id
     * @private
     * @returns string
     */
    private get id(): string
    {
        return this.$route.query && (this.$route.query.id as string) || "";
    }

    /**
     * 产品id
     * @private
     * @returns string
     */
    private get productId(): string
    {
        return this.$route.query && (this.$route.query.productId as string) || "";
    }

    /**
     * 权益id
     * @private
     * @returns string
     */
     private get rightsId(): string
    {
        return this.$route.query && (this.$route.query.rightsId as string) || "";
    }

    /**
     * 商品总价格
     * @private
     * @returns number
     */
    private get sumPrice(): number
    {
        return (this.goodsNum * this.dataModel.unitPrice) ? +(this.goodsNum * this.dataModel.unitPrice).toFixed(2) : 0
    }

    /**
     * 最终支付金额
     * @protected
     * @returns string
     */
     protected finalSumPrice: any = 0;

     /**
     * 优惠券id
     * @private
     * @returns string
     */
    private get couponId(): any
    {
        return this.couponInfo.couponId || null;
    }

    /**
     * 监听steper变化
     * @private
     * @returns void
     */
    @Watch("sumPrice")
    private async onChangeSumPrice(value: any): Promise<any>
    {
        if(value)
        {
            this.productId && await this.getCouponSuitable();
            this.finalSumPrice = (this.couponInfo && (this.couponInfo.finalAmount || this.couponInfo.finalAmount === 0)) ? this.couponInfo.finalAmount : this.sumPrice;
        }
    }

    /**
     * 监听steper变化
     * @private
     * @returns void
     */
     @Watch("couponInfo")
    private async onChangeSumPriceCoupon(value: any): Promise<any>
    {
        if(value)
        {
            this.finalSumPrice = (this.couponInfo && (this.couponInfo.finalAmount || this.couponInfo.finalAmount === 0)) ? this.couponInfo.finalAmount : this.sumPrice;
        }
    }

    /**
     * 修改地址
     * @private
     * @param {params}
     * @returns {Promise<void>}
     */
     private async onUpdateAddress(): Promise<void>
    {
        if (this.dataModel.addressId)   // 地址列表存在值
        {
            this.$router.push({name:"goods-order-update-address", query:{id: this.id, addressId: this.dataModel.addressId, status: this.dataModel.status}});
        }
        else
        {
            this.$router.push({name: "address-detail"});
        }
    }

    /**
     * 组件创建钩子
     * @protected
     * @returns void
     */
    protected created()
    {
        if(!localStorage.getItem("userInfo"))
        {
            this.$router.replace({name:"login", query:{redirect: location.href}});
            return;
        }
        this.getPreGoodsOrderInfo(this.id);
        this.$nextTick(() => {
            if (this.rightsId)
            {
                this.getCardByMemberRightId();
            }
        })
    }

    /**
     * 获取订单列表
     * @private
     * @returns void
     */
     private async getCardByMemberRightId(): Promise<void>
    {
        try
        {
            let { content: result } = await rightsService.instance.clientGetCardByMemberRightId(this.rightsId);
            if(result.data)
            {
                this.cardInfo = result.data;
            }
        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 组件进来之前
     * @private
     * @returns void
     */
    private beforeRouteEnter(to, from, next): void
    {
        let appid = localStorage.getItem("appid");
        if (!tools.isAndroid() && `/${appid}${to.path}` !== location.pathname)
        {
           location.assign(`/${appid}${to.fullPath}`);
        }
        else
        {
            next();
        }
    }

    /**
     * 获取产品下单前数据
     * @public
     * @param {params}
     * @returns {Promise<IHttpResponse>}
     */
    public async getPreGoodsOrderInfo(id: string): Promise<void>
    {
        try
        {
            const isRights = this.rightsId ? true : null;
            let {content: result} = await GoodsOrderService.instance.getPreGoodsOrderInfo(id,isRights);

            if(result.data)
            {
                this.dataModel = result.data;
                this.productId && this.getCouponSuitable();
            }

            let selectAddressInfoStorage = localStorage.getItem("selectAddressInfo");

            if(selectAddressInfoStorage)
            {
                let selectAddressInfo = JSON.parse(selectAddressInfoStorage);
                this.dataModel.address = selectAddressInfo.address;
                this.dataModel.receiverName = selectAddressInfo.receiverName;
                this.dataModel.phone = selectAddressInfo.phone;
                this.dataModel.addressId = selectAddressInfo.id;
                localStorage.removeItem("selectAddressInfo");
            }
            else
            {
                this.getAddressList();
            }
        }
        catch(err)
        {
            Toast(JSON.stringify(err));
        }

    }

    /**
     * 获取优惠券列表
     * @private
     * @returns void
     */
     private async getCouponSuitable(): Promise<void>
    {
        try
        {
            let params = {
                id: this.productId,
                amount: this.sumPrice
            };
            let {content: result} =  await EmployerActivityService.instance.couponSuitable(params, false);

            if(result.data)
            {
                this.couponList = result.data;
                this.couponInfo = result.data[0] || {};
            }

        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 获取地址列表
     * @private
     * @returns void
     */
    private async getAddressList()
    {
        try{
           
            let {content: result} = await AddressService.instance.getAddressList();

            if(result.data)
            {
                if (result.data.length > 0)
                {
                    this.dataModel.address = result.data[0].address;
                    this.dataModel.receiverName = result.data[0].receiverName;
                    this.dataModel.phone = result.data[0].phone;
                    this.dataModel.addressId = result.data[0].id;
                }
            }
        }
        catch(err)
        {
            Toast(JSON.stringify(err))
        }
    } 

    /**
     * 提交订单
     * @public
     * @param {params}
     */
    public async onSubmit(id: string): Promise<void>
    {
        try
        {
            if(!this.dataModel.addressId)
            {
                Toast("请先选择收货地址!");
                return;
            }
            let data = {
                productId: this.dataModel.productId,
                addressId: this.dataModel.addressId,
                productQty: this.goodsNum,
                rightsId:this.rightsId,
                couponId: this.couponInfo.couponId || null,
            }
            let {content: result} = await GoodsOrderService.instance.createGoodsOrder(data);
            
            if(result.data)
            {

                if(result.data.isNeedPay)
                {
                    this.$router.push({name: "pay", query:{orderNo: result.data.orderNo}});
                    // // 需要支付
                    // Pay.onBridgeReady(result.data,
                    //     ()=> this.onSucessDetail(result.data.orderId), 
                    //     ()=> this.onActionOrderDetail(result.data.orderId)
                    // )
                }
                else
                {
                    this.$router.push({name: "goods-order-sucess", query:{id: result.data.orderId}});
                }
            }
        }
        catch(err)
        {
            Toast(JSON.stringify(err));
        }

    }

    /**
     * 跳转成功页面
     * @private
     * @returns void
     */
     private onSucessDetail(id: string): void
    {
        this.$router.push({name: "goods-order-sucess", query:{id: id}});
    }

    /**
     * 跳转订单明细
     * @private
     * @returns void
     */
    private onActionOrderDetail(id: string): void
    {
        this.$router.push({name: "goods-order-detail", query:{id: id}});
    }

    /**
     * 确认切换优惠券
     * @private
     * @returns void
     */
    protected onConfirmCoupon(data: any): void
    {
        if (data) {
            this.couponInfo = data;
        }
        else {
            this.couponInfo = {
                finalReduceAmount: null,
                finalAmount: null,
                couponId: null,
            };
        }
        this.showCouponPopup = false;
    }

}
